import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=39b13ef0"
import script from "./CompanyProfile.vue?vue&type=script&lang=js"
export * from "./CompanyProfile.vue?vue&type=script&lang=js"
import style0 from "./CompanyProfile.vue?vue&type=style&index=0&id=39b13ef0&prod&lang=scss"
import style1 from "./CompanyProfile.vue?vue&type=style&index=1&id=39b13ef0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports